/*
 * SonarQube
 * Copyright (C) 2009-2024 SonarSource SA
 * mailto:info AT sonarsource DOT com
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with this program; if not, write to the Free Software Foundation,
 * Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */
.modal,
.ReactModal__Content {
  position: fixed;
  z-index: 6001;
  top: 0;
  left: 50%;
  margin-left: -270px;
  width: 540px;
  background-color: #fff;
  opacity: 0;
  transition: all 0.2s ease;
  border-radius: 3px;
}

.modal:focus,
.ReactModal__Content:focus {
  outline: none;
}

.modal.in,
.ReactModal__Content--after-open {
  top: 15%;
  opacity: 1;
}

.modal-small {
  width: 450px;
  margin-left: -225px;
}

.modal-medium {
  width: 830px;
  margin-left: -415px;
}

.modal-large {
  width: calc(100% - 40px);
  max-width: 1280px;
  min-width: 1040px;
  margin-left: 0;
  transform: translateX(-50%);
}

.modal-overlay,
.ReactModal__Overlay {
  position: fixed;
  z-index: 6000;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  opacity: 0;
  transition: all 0.2s ease;
}

.modal-overlay.in,
.ReactModal__Overlay--after-open {
  opacity: 1;
}

.modal-no-backdrop {
  background-color: transparent;
}

.modal-open,
.ReactModal__Body--open {
  overflow: hidden;
  margin-right: var(--sbw);
}

.modal-head {
  padding: 32px;
  padding-bottom: 0;
}

.modal-head h1,
.modal-head h2 {
  margin: 0;
  font-size: 16px;
  font-weight: bold;
  line-height: normal;
  overflow-wrap: break-word;
}

.modal-body {
  padding: 20px 32px;
}

.modal-container {
  max-height: 60vh;
  box-sizing: border-box;
  overflow-y: auto;
  border-top: 1px solid #e6e6e6;
  margin-top: 20px;
  padding-right: 32px;
}

.modal-container > :last-child {
  margin-bottom: 20px;
}

.modal-field,
.modal-validation-field {
  clear: both;
  display: block;
  padding: 0;
  margin-bottom: 16px;
}

.modal-field label,
.modal-validation-field label,
.modal-field legend {
  display: block;
  font-weight: bold;
  padding-bottom: 4px;
}

.modal-field a.icon-checkbox,
.modal-field input,
.modal-field select,
.modal-field textarea,
.modal-field .Select {
  margin-right: 5px;
}

.modal-field a.icon-checkbox {
  height: 24px;
}

.modal-field input[type='radio'],
.modal-field input[type='checkbox'] {
  margin-top: 5px;
  margin-bottom: 4px;
}

.modal-field > .icon-checkbox {
  padding-top: 6px;
  padding-right: 8px;
}

.modal-field input[type='text'],
.modal-field input[type='email'],
.modal-field input[type='password'],
.modal-field textarea,
.modal-field select,
.modal-field .Select {
  width: 100%;
}

.modal-validation-field input,
.modal-validation-field textarea,
.modal-validation-field .Select {
  margin-right: 8px;
  margin-bottom: 2px;
  width: calc(100% - 24px);
}

.modal-field textarea,
.modal-validation-field textarea {
  max-width: 100%;
  min-width: 100%;
  max-height: 50vh;
  min-height: 24px;
}
.modal-validation-field input:not(.is-invalid),
.modal-validation-field .Select:not(.is-invalid) {
  margin-bottom: 18px;
}

.modal-field-description {
  line-height: 1.4;
  color: #656565;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 2px;
}

.modal-field input[type='text'].invalid {
  border-color: #D02F3A;
}

.modal-foot {
  padding: 20px 32px;
  border-top: 1px solid #e6e6e6;
  background-color: #f3f3f3;
  border-radius: 3px;
  text-align: right;
}

.modal-foot button,
.modal-foot .button,
.modal-foot input[type='submit'],
.modal-foot input[type='button'] {
  margin-left: 8px;
}

.modal-foot button:first-of-type,
.modal-foot .button:first-of-type,
.modal-foot input[type='submit']:first-of-type,
.modal-foot input[type='button']:first-of-type {
  margin-left: 0;
}

.modal-foot-clear {
  border-top: 0;
  background-color: transparent;
}
